import AnimatedCounter from "./animatedCounter";

export default AnimatedCounter;
